import apiUrl from '../../../constants'
import axios from 'axios'
import ShipmentBagSummary from './ShipmentBagSummary/index.vue';
import CargoShipmentBagSummary from './CargoShipmentBagSummary/index.vue';
import BinShimentSummary from './BinShimentSummary/index.vue';
import MultiPartGroupSummary from './MultiPartGroupSummary/index.vue';


export default {
  name: 'bag-shipment-query',
  components: {
    'first': ShipmentBagSummary,
    'second': CargoShipmentBagSummary,
    'third': BinShimentSummary,
    'fourth': MultiPartGroupSummary
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Ecom'
        },
        {
          key: 'Second',
          value: 'Cargo'
        },
        {
          key: 'Third',
          value: 'Bin'
        },
        {
          key: 'Fourth',
          value: 'MultiPartGroupSummary'
        }
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/BagShipmentQuery/BagShipmentQuery.js